export const operationTabs = {
  GENERAL: 1,
  DATA: 2,
  OPERATIONS: 3,
  DATA_PAPERWORK: 4,
  OPERATIONS_PAPERWORK: 5,
  DATA_PURCHASE: 6,
  OPERATIONS_PURCHASE: 7
}
